module.exports = __webpack_public_path__ + "img/thumbnail_NileLechwe_f_normal.7087367a.png";